import { IFavorite, v1FavoritesGet } from '@ifit/gateway-wolf-dashboard-service';
import { useQuery, UseQueryResult } from 'react-query';
import { FIVE_SECONDS, ONE_DAY } from '../../util/durations';
import { useFeatureFlags } from '../../hooks/use-feature-flags';
import { FeatureFlag } from '../../types';
import { useLanguage } from '../selectors/use-language';
import { useSoftwareNumber } from '../selectors/use-software-number';
import { useUserId } from '../selectors/use-user-id';

export function useFavorites(disableCall: boolean): UseQueryResult<IFavorite[], Error> {
  const softwareNumber = useSoftwareNumber();
  const userId = useUserId();
  const language = useLanguage();
  const featureFlags = useFeatureFlags([FeatureFlag.Challenges]);
  const challengeStoreEnabled = featureFlags[FeatureFlag.Challenges];

  return useQuery<IFavorite[], Error>(
    ['favorites', { challengeStoreEnabled, softwareNumber, userId, language }],
    () =>
      v1FavoritesGet({
        challengeStoreEnabled,
        softwareNumber,
        page: 1,
        pageSize: 10,
        headers: { language },
      }),
    { staleTime: FIVE_SECONDS, cacheTime: ONE_DAY, enabled: Boolean(!disableCall) }
  );
}
